import { Directive, Input, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDisableFormControl]',
  exportAs: 'appDisableFormControl',
})
export class DisableFormControlDirective {
  private ngControl = inject(NgControl);

  @Input() set appDisableFormControl(condition: boolean) {
    const control = this.ngControl.control;
    if (!control) {
      return;
    }

    const shouldDisable = !!condition;
    if (shouldDisable && control.disabled) {
      return;
    }
    if (!shouldDisable && control.enabled) {
      return;
    }

    if (shouldDisable) {
      control.disable({ emitEvent: false });
      return;
    }

    control.enable({ emitEvent: false });
  }
}
